/*
  FaD v5.61 — collapse the mobile review wall
  --------------------------------------------------------------
  Nine review cards stack into a single column on mobile, roughly
  five phone screens. Reviews now sit at position 3 for the social
  proof, so on mobile we show three and let people expand.

  Progressive enhancement: if this script never runs, every review
  renders as before and nothing is hidden.
*/
(function () {
  'use strict';

  var MQ = '(max-width: 767px)';

  function init() {
    var grid = document.getElementById('fad-reviews-grid');
    var btn = document.getElementById('fad-reviews-more');
    if (!grid || !btn) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.rcard'));
    var keep = parseInt(grid.getAttribute('data-mobile-visible'), 10) || 3;
    if (cards.length <= keep) return;

    var hidden = cards.slice(keep);
    hidden.forEach(function (c) { c.setAttribute('data-review-hidden', ''); });

    var label = btn.querySelector('.reviews-more__label');
    var expanded = false;

    function setState(open) {
      expanded = open;
      grid.classList.toggle('is-collapsed', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Show fewer reviews' : 'Read all ' + cards.length + ' reviews';
      hidden.forEach(function (c) { c.setAttribute('aria-hidden', open ? 'false' : 'true'); });
    }

    function apply(isMobile) {
      if (isMobile) {
        btn.hidden = false;
        setState(expanded);
      } else {
        btn.hidden = true;
        grid.classList.remove('is-collapsed');
        hidden.forEach(function (c) { c.setAttribute('aria-hidden', 'false'); });
      }
    }

    btn.addEventListener('click', function () {
      var wasCollapsed = !expanded;
      setState(wasCollapsed);
      /* collapsing from far down the list would strand the reader */
      if (!wasCollapsed) {
        var top = grid.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });

    var mql = window.matchMedia(MQ);
    apply(mql.matches);
    if (mql.addEventListener) {
      mql.addEventListener('change', function (e) { apply(e.matches); });
    } else if (mql.addListener) {
      mql.addListener(function (e) { apply(e.matches); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
